<template>
<div>
  <b-alert show variant="danger" class="text-center">Henüz veri yok</b-alert>
</div>
</template>

<script>
export default {
  name: "NoDataYet"
}
</script>

<style scoped>

</style>